<template>
  <div class="connect_to_wifi">
    <header-component :is-soon="false" :backRoute="false" :progression="false" img-left=""
      img-right="/trocachip/img/access.png" class="header-component" />
    <div class="connection-img">
      <img src="@/assets/images/connection-small.png" />
    </div>
    <div class="connect_wifi_title">
      <span>{{ pageInfo.title }}</span>
    </div>
    <div class="protocol">
      <span class="protocol_span">{{ pageInfo.protocol_title }}</span>
      <span class="protocol_span">{{ protocol }}</span>
    </div>
    <div class="wifi_instructions">
      <span class="wifi_instructions_span">{{ pageInfo.warning_message_1 }}</span>
      <span class="wifi_instructions_span">{{ pageInfo.warning_message_2 }}</span>
    </div>
    <div class="next_submit">
      <button id="submitConnected" class="btn_next" :class="{
        btn_next_active: true,
        'ac-border-yellow': ac,
        'ac-color-yellow': ac,
        'ac-bg-gray': ac,
      }" @click="next">
        <loader-bottom v-if="loader" />
        <span v-if="!loader">{{ pageInfo.action_button_black }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderComponent from "@/components/HeaderComponent.vue";
import trackEvent from "@/services/trackEvent";

export default {
  name: "ConnectToWifi",
  components: { HeaderComponent },
  data() {
    return {
    };
  },
  watch: {
    email: function () {
      if (this.email) {
        this.validateEmail();
      }
    },
  },
  created() {
    this.sendTracker("conectar_wifi", 6, 3);
    this.$store.dispatch("disableBack", true)
    window.history.pushState(null, null, window.location.href);
    this.sendCustomDimension('Protocolo_TC', this.protocol);
    window.onpopstate = function () {
      window.history.go(1);
    };
  },
  computed: {
    ...mapState({
      ac: (state) => state.ac,
      config: (state) => state.config,
      customer: (state) => state.customer,
      protocol: (state) => state.protocol,
      pageInfo: (state) => state.config.connect_to_wifi
    }),
  },
  methods: {
    sendTracker(eventLabel, eventCategory = 6, eventAction = 2) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": eventCategory,
        "event-label": eventLabel,
        "event-location": "null",
        "event-value": this.customer.isExOiCustomer ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": eventAction,
      });
    },
    async sendCustomDimension(dimension, value) {
    // Convert value to string if it's not already
    const strValue = String(value);

    // Replace spaces, asterisks, and parentheses
    const sanitizedValue = strValue
        .replace(/\s/g, '_')    // Replace spaces with underscores
        .replace(/\*/g, '_')     // Remove asterisks
        .replace(/[()]/g, '_');  // Remove parentheses - no need to escape inside []
    console.log("Sending " + dimension + ": " + sanitizedValue);
    const command = `decibelInsight("sendCustomDimension", "${dimension}", "${sanitizedValue}");`;
console.log(command)
    window.eval(command);
},
    next() {
      this.sendTracker("conectar_wifi_continuar");
      this.$router.push({ name: "installationTarget" });
    }
  },
};
</script>

<style lang="scss" scoped>
.connect_to_wifi {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  z-index: -1;

  >.page_content {
    margin: 25% 0%;
  }

  .connection-img {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 85px;
  }

  .connect_wifi_title {
    font-weight: 300;
    font-size: 27px;
    line-height: 30px;
    align-items: center;
    display: flex;
    font-family: "timsans_regular";
    width: 280px;
    text-align: center;
    flex-direction: column;
    margin: auto;
    margin-top: 1rem;
  }

  .protocol {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "timsans_regular";
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    margin-top: 1rem;
    color: #696969;
  }

  .wifi_instructions {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "timsans_regular";
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    margin-top: 1rem;
    color: #696969;
    width: 325px;
    margin: auto;
  }

  .wifi_instructions_span {
    margin-top: 1rem;
  }
}
</style>